import { drawer as audiencesDrawer } from "./optional/audiences/drawer.ts";
import { place as audiencesPlace } from "./optional/audiences/place.ts";
import { cues as creativeWatchCues } from "./optional/creative-watch/cues.ts";
import { drawer as dailyDiaryDrawer } from "./optional/daily-diary/drawer.ts";
import { place as dailyDiaryPlace } from "./optional/daily-diary/place.ts";
import { alerts as driveCreativesAlerts } from "./optional/drive-creatives/alerts.ts";
import { drawer as driveCreativesDrawer } from "./optional/drive-creatives/drawer.ts";
import { place as driveCreativesPlace } from "./optional/drive-creatives/place.ts";
import { steps as driveCreativesSteps } from "./optional/drive-creatives/steps.ts";
import { alerts as eventRoundsAlerts } from "./optional/event-rounds/alerts.ts";
import { journal as freshCampaignJournal } from "./optional/fresh-campaign/journal.ts";
import { drawer as googleSignInDrawer } from "./optional/google-sign-in/drawer.ts";
import { place as googleSignInPlace } from "./optional/google-sign-in/place.ts";
import { overview as growthPlanningOverview } from "./optional/growth-planning/overview.ts";
import { drawer as growthPlanningDrawer } from "./optional/growth-planning/drawer.ts";
import { place as growthPlanningPlace } from "./optional/growth-planning/place.ts";
import { journal as newAdsJournal } from "./optional/new-ads/journal.ts";
import { drawer as notifyDrawer } from "./optional/notify/drawer.ts";
import { drawer as ownerWeekDrawer } from "./optional/owner-week/drawer.ts";
import { place as ownerWeekPlace } from "./optional/owner-week/place.ts";
import { sections as stockRuleSections } from "./optional/stock-rule/sections.ts";
import { alerts as stockRuleAlerts } from "./optional/stock-rule/alerts.ts";
import { overview as storeInsightsOverview } from "./optional/store-insights/overview.ts";
import { drawer as teamRequestsDrawer } from "./optional/team-requests/drawer.ts";
import { place as teamRequestsPlace } from "./optional/team-requests/place.ts";
import { alerts as trackingHealthAlerts } from "./optional/tracking-health/alerts.ts";
import { steps as trackingHealthSteps } from "./optional/tracking-health/steps.ts";
import { journal as videoSpeechJournal } from "./optional/video-speech/journal.ts";

export const catalog = {
  "audiences": { drawer: audiencesDrawer, place: audiencesPlace },
  "creative-watch": { cues: creativeWatchCues },
  "daily-diary": { drawer: dailyDiaryDrawer, place: dailyDiaryPlace },
  "drive-creatives": { alerts: driveCreativesAlerts, drawer: driveCreativesDrawer, place: driveCreativesPlace, steps: driveCreativesSteps },
  "event-rounds": { alerts: eventRoundsAlerts },
  "fresh-campaign": { journal: freshCampaignJournal },
  "google-sign-in": { drawer: googleSignInDrawer, place: googleSignInPlace },
  "growth-planning": { overview: growthPlanningOverview, drawer: growthPlanningDrawer, place: growthPlanningPlace },
  "new-ads": { journal: newAdsJournal },
  "notify": { drawer: notifyDrawer },
  "owner-week": { drawer: ownerWeekDrawer, place: ownerWeekPlace },
  "stock-rule": { sections: stockRuleSections, alerts: stockRuleAlerts },
  "store-insights": { overview: storeInsightsOverview },
  "team-requests": { drawer: teamRequestsDrawer, place: teamRequestsPlace },
  "tracking-health": { alerts: trackingHealthAlerts, steps: trackingHealthSteps },
  "video-speech": { journal: videoSpeechJournal },
};
